import { Text, Spacer } from "@hackthenorth/north";
import { Button } from "north.js";
import React from "react";

import Modal from "src/shared/components/Modal";

interface WithdrawModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
}

const WithdrawModal: React.FC<WithdrawModalProps> = ({
  onConfirm,
  onCancel,
  isOpen,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Are you sure you don’t want to attend Hack the North 2026?"
      actions={
        <>
          <Button color="tertiary" size="lg" onClick={onCancel}>
            No, return to RSVP
          </Button>
          <Spacer width="36px" />
          <Button color="primary" size="lg" onClick={onConfirm}>
            Withdraw my spot now
          </Button>
        </>
      }
    >
      <Text mods="grey">
        Once you withdraw your application, you will be unable to attend Hack
        the North 2026.
      </Text>
    </Modal>
  );
};

export default WithdrawModal;
